import { NEUTRA_LETTERS_SELECTOR } from "../4-one-of-one/_selectors";
import selectSingleElement from "../dom/selectSingleElement";

export default function isNeutraFont(): boolean {
	const activeFont = selectSingleElement<HTMLSpanElement>(
		`${NEUTRA_LETTERS_SELECTOR}.selected-font`,
	);
	return activeFont !== null;
}
